import React from "react";
import { useState, useEffect } from "react";
import styles from "./MyApplicationsMain.module.css";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import greater from "../../../assets/images/greater.svg";
import greater2 from "../../../assets/images/greater2.svg";
import confirmation from "../../../assets/images/confirmation.svg";
import cancel from "../../../assets/images/cancel.svg";
import print from "../../../assets/images/print.svg";
import documentImage from "../../../assets/images/document.svg";

import { allApplicationsApi } from "../../../config/allApplicationsApi";
import { updateApplicationApi } from "../../../config/updateApplicationApi";
import { approveApplicationApi } from "../../../config/approveApplicationApi";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import moment from "moment";
import { FaGreaterThan } from "react-icons/fa";

import { Link, useHistory } from "react-router-dom";

import {
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
} from "mdbreact";

import Tooltip from "@material-ui/core/Tooltip";
import { Divider } from "@material-ui/core";

import { IoChevronDownOutline } from "react-icons/io5";
import Collapsible from "react-collapsible";

import PropTypes from "prop-types";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import StepConnector from "@material-ui/core/StepConnector";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { GoCheck } from "react-icons/go";
import { HiDotsHorizontal } from "react-icons/hi";
import { Rotate90DegreesCcw } from "@material-ui/icons";

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 20,
  },
  active: {
    "& $line": {
      backgroundColor: "#27AE60",
    },
  },
  completed: {
    "& $line": {
      backgroundColor: "#27AE60",
    },
  },
  line: {
    height: 3.5,
    border: 0,
    backgroundColor: "#D1E1EA",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ffffff",
    zIndex: 1,
    color: "#fff",
    width: 40,
    height: 40,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    border: "4px solid #D1E1EA",
    backgroundColor: "#ffffff",
  },
  active: {
    border: "4px solid #D56A04",
    backgroundColor: "#ffffff",
  },
  completed: {
    border: "4px solid #27AE60",
    backgroundColor: "#ffffff",
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  return (
    <>
      {completed ? (
        <div
          className={clsx(classes.root, {
            [classes.active]: active,
            [classes.completed]: completed,
          })}
        >
          <GoCheck size={26} color="#27AE60" />
        </div>
      ) : (
        <>
          {active ? (
            <div
              className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
              })}
            >
              <HiDotsHorizontal size={26} color="#D56A04" />
            </div>
          ) : (
            <div
              className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
              })}
            ></div>
          )}
        </>
      )}
    </>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  text: {
    fontFamily: "Montserra",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "18px",
    color: "#7FA2B6",
  },
}));

function getSteps() {
  return [
    "Payment",
    "Application form",
    "Visa Officer",
    "Supervisor",
    "Embassy",
  ];
}

function CustomizedSteppers(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(props.num);
  const steps = getSteps();

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              <span className={classes.text}>{label}</span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}

function MyApplicationsMain() {
  const [toggleState, setToggleState] = useState(0);
  const [loader, setLoader] = useState(true);

  const [allApplications, setAllApplications] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [pending, setPending] = useState([]);
  const [canceled, setCanceled] = useState([]);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const allTabs = [
    { name: "All applications" },
    { name: "Completed" },
    { name: "Pending" },
    { name: "Canceled" },
  ];
  const allConts = [
    { app: allApplications, error: "No Applications Available." },
    { app: completed, error: "No Applications Was Completed." },
    { app: pending, error: "No Applications Is Pending." },
    { app: canceled, error: "No Applications Was Canceled." },
  ];
  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      const allApplications = async (token) => {
        const allapplications = await allApplicationsApi(token);

        if (allapplications.data) {
          console.log(allapplications.data.data);

          const Applications = await allapplications.data.data;
          Applications.reverse();

          setAllApplications([]);
          setPending([]);
          setCompleted([]);
          setCanceled([]);
          let completedCount = 0;
          let inCompleteCount = 0;
          Applications.map((value, index) => {
            if (true) {
              completedCount *= 0;
              inCompleteCount *= 0;
            }

            value.travellers_informations.map((value, index) => {
              if (value.status === "COMPLETED") {
                completedCount += 1;
              } else if (value.status === "INCOMPLETE" && value.passport_number !== null) {
                inCompleteCount += 1;
              }
            });

            if (value.status === "CANCELLED") {
              setAllApplications((allApplications) => [
                ...allApplications,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,
                  plan_type: value.plan_type,
                  num:
                    value.status === "SUCCESSFUL"
                      ? 5
                      : value.supervisor.status !== "UNASSIGNED"
                        ? 4
                        : value.visa_officer.status !== "UNASSIGNED"
                          ? 3
                          : completedCount >= value.travellers_count
                            ? 2
                            : value.payment_status === "PAID"
                              ? 1
                              : 0,
                  newNum: ((inCompleteCount) !== 0 && (!(completedCount >= value.travellers_count)))
                    ? true
                    : false,

                  visa_officer:
                    value.visa_officer.assigned_to !== null
                      ? value.visa_officer.assigned_to
                      : "Not Assigned Yet",
                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                  application: value
                },
              ]);

              setCanceled((canceled) => [
                ...canceled,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,
                  status: value.payment_status,
                  plan_type: value.plan_type,
                  num:
                    value.status === "SUCCESSFUL"
                      ? 5
                      : value.supervisor.status !== "UNASSIGNED"
                        ? 4
                        : value.visa_officer.status !== "UNASSIGNED"
                          ? 3
                          : completedCount >= value.travellers_count
                            ? 2
                            : value.payment_status === "PAID"
                              ? 1
                              : 0,
                  newNum: ((inCompleteCount) !== 0 && (!(completedCount >= value.travellers_count)))
                    ? true
                    : false,

                  visa_officer:
                    value.visa_officer.assigned_to !== null
                      ? value.visa_officer.assigned_to
                      : "Not Assigned Yet",

                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                  application: value
                },
              ]);
            } else if (
              value.status === "SUCCESSFUL" ||
              value.status === "REJECTED"
            ) {
              setAllApplications((allApplications) => [
                ...allApplications,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,
                  plan_type: value.plan_type,
                  num:
                    value.status === "SUCCESSFUL"
                      ? 5
                      : value.supervisor.status !== "UNASSIGNED"
                        ? 4
                        : value.visa_officer.status !== "UNASSIGNED"
                          ? 3
                          : completedCount >= value.travellers_count
                            ? 2
                            : value.payment_status === "PAID"
                              ? 1
                              : 0,
                  newNum: ((inCompleteCount) !== 0 && (!(completedCount >= value.travellers_count)))
                    ? true
                    : false,

                  visa_officer:
                    value.visa_officer.assigned_to !== null
                      ? value.visa_officer.assigned_to
                      : "Not Assigned Yet",

                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                  application: value
                },
              ]);
              setCompleted((completed) => [
                ...completed,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,
                  plan_type: value.plan_type,
                  num:
                    value.status === "SUCCESSFUL"
                      ? 5
                      : value.supervisor.status !== "UNASSIGNED"
                        ? 4
                        : value.visa_officer.status !== "UNASSIGNED"
                          ? 3
                          : completedCount >= value.travellers_count
                            ? 2
                            : value.payment_status === "PAID"
                              ? 1
                              : 0,
                  newNum: ((inCompleteCount) !== 0 && (!(completedCount >= value.travellers_count)))
                    ? true
                    : false,

                  visa_officer:
                    value.visa_officer.assigned_to !== null
                      ? value.visa_officer.assigned_to
                      : "Not Assigned Yet",

                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                  application: value
                },
              ]);
            } else {
              setAllApplications((allApplications) => [
                ...allApplications,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,
                  plan_type: value.plan_type,
                  num:
                    value.status === "SUCCESSFUL"
                      ? 5
                      : value.supervisor.status !== "UNASSIGNED"
                        ? 4
                        : value.visa_officer.status !== "UNASSIGNED"
                          ? 3
                          : completedCount >= value.travellers_count
                            ? 2
                            : value.payment_status === "PAID"
                              ? 1
                              : 0,
                  newNum: ((inCompleteCount) !== 0 && (!(completedCount >= value.travellers_count)))
                    ? true
                    : false,

                  visa_officer:
                    value.visa_officer.assigned_to !== null
                      ? value.visa_officer.assigned_to
                      : "Not Assigned Yet",

                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                  application: value
                },
              ]);
              setPending((pending) => [
                ...pending,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,
                  plan_type: value.plan_type,
                  num:
                    value.status === "SUCCESSFUL"
                      ? 5
                      : value.supervisor.status !== "UNASSIGNED"
                        ? 4
                        : value.visa_officer.status !== "UNASSIGNED"
                          ? 3
                          : completedCount >= value.travellers_count
                            ? 2
                            : value.payment_status === "PAID"
                              ? 1
                              : 0,
                  newNum: ((inCompleteCount) !== 0 && (!(completedCount >= value.travellers_count)))
                    ? true
                    : false,

                  visa_officer:
                    value.visa_officer.assigned_to !== null
                      ? value.visa_officer.assigned_to
                      : "Not Assigned Yet",

                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                  application: value
                },
              ]);
            }
          });
          setLoader(false);
        } else if (allapplications.error) {
          console.log(allapplications.error);
          setLoader(false);
        }
      };
      allApplications(item.value.token);
    }
    getWithExpiry("userData");
  }, []);

  return (
    <>
      {loader ? (
        <>
          <div className={styles.headCont}>
            <h2 className={styles.head}>My applications</h2>
            <Link to="/dashboard/plan-a-trip">
              <button className={styles.headBtn}>Start New</button>
            </Link>
          </div>
          <div className={styles.loader}>
            <div className="spinner-border" role="status"></div>
          </div>
        </>
      ) : (
        <div className={styles.container}>
          <div className={styles.headCont}>
            <h2 className={styles.head}>My applications</h2>
            <Link to="/dashboard/plan-a-trip">
              <button className={styles.headBtn}>Start New</button>
            </Link>
          </div>
          <div className={styles.bloctabs}>
            {allTabs.map((value, index) => (
              <button
                key={index}
                className={
                  toggleState === index ? styles.activetabs : styles.tabs
                }
                onClick={() => toggleTab(index)}
              >
                {value.name}
              </button>
            ))}
          </div>

          <div className={styles.contenttabs}>
            {allConts.map((value, index) => (
              <div
                key={index}
                className={
                  toggleState === index ? styles.activecontent : styles.content
                }
              >
                <Tableone data={value.app} error={value.error} />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default MyApplicationsMain;

function Tableone(props) {
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const data = props.data;
  const error = props.error;

  const [loader1, setLoader1] = useState(true);

  const [open, setOpen] = useState(false);

  const [loading1, setLoading1] = useState(false)

  const cancelTRansaction = (id) => {
    setLoading(true);

    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      const updateApplication = async (token) => {
        const update = await updateApplicationApi(id, token);

        if (update.data) {
          console.log(update.data);
          setLoader1(false);
          window.location.reload();
        } else if (update.error) {
          console.log(update.error);
          setLoader1(false);
        }
      };
      updateApplication(item.value.token);
    }
    getWithExpiry("userData");
  };

  const action = (applicationId) => {
    history.push(
      `/dashboard/my-applications/application-center/${applicationId}`
    );
  };

  const approve = (id) => {
    setLoading1(true);

    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      const approveApplication = async (token) => {
        setLoading1(true)
        const approveapplication = await approveApplicationApi(
          token,
          { status: "APPROVED" },
          id
        );

        if (approveapplication.data) {
          console.log(approveapplication.data);
          setLoading1(false);

          toast.success(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BsCheckAll size="30" style={{ marginRight: "10px" }} />
              Application Approved Successfully!
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );

          setTimeout(() => {
            window.location.reload();
          }, 1500);

        } else if (approveapplication.error) {
          console.log(approveapplication.error);
          setLoading1(false);

          toast.error(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BiError size="30" style={{ marginRight: "10px" }} />
              {approveapplication.error.message}
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
        }
      };
      approveApplication(item.value.token);
    }
    getWithExpiry("userData");
  }

  return (
    <div className={styles.main}>
      <div className={styles.secondSection}>
        <div className={styles.secondInsideBox}>
          {loading ? (
            <div className={styles.loader}>
              <div className="spinner-border" role="status"></div>
            </div>
          ) : data.length === 0 ? (
            <div className={styles.lengthCont}>
              <h2 className={styles.contHead}>{error}</h2>
            </div>
          ) : (
            <>
              <TableContainer
                component={Paper}
                style={{ boxShadow: "none" }}
                className={styles.allTable}
              >
                <Table aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" className={styles.tableInHead}>
                        <div className={styles.tableHead}>Destination</div>
                      </TableCell>
                      <TableCell align="center" className={styles.tableInHead}>
                        <div className={styles.tableHead}>Status</div>
                      </TableCell>
                      <TableCell align="center" className={styles.tableInHead}>
                        <div className={styles.tableHead}>Action</div>
                      </TableCell>
                      <TableCell align="center" className={styles.tableInHead}>
                        <div className={styles.tableHead}></div>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                </Table>
              </TableContainer>

              {data.map((value, index) => (
                <Collapsible
                  transitionTime={100}
                  trigger={
                    <TableContainer
                      component={Paper}
                      style={{ boxShadow: "none" }}
                      className={styles.allTable}
                      onClick={() => setOpen((open) => !open)}
                    >
                      <Table aria-label="caption table">
                        <TableBody>
                          <TableRow key={index}>
                            <TableCell
                              className={styles.tableInHead}
                              align="center"
                            >
                              <div className={styles.tableInHead1}>
                                {value.country}
                                <div className={styles.details}>
                                  {value.visa_type}
                                </div>
                              </div>
                            </TableCell>
                            <TableCell
                              className={styles.tableInHead}
                              align="center"
                            >
                              <div className={styles.btnOne}>
                                {value.status !== undefined ? (
                                  value.status === "CANCELLED" ? (
                                    <span className={styles.hiddenBtn1}>
                                      {value.status
                                        .replace(/_/g, " ")
                                        .toLowerCase()}
                                    </span>
                                  ) : (
                                    <span className={styles.status}>
                                      {value.status
                                        .replace(/_/g, " ")
                                        .toLowerCase()}
                                    </span>
                                  )
                                ) : (
                                  <span className={styles.status}>
                                    Not Available
                                  </span>
                                )}
                              </div>
                            </TableCell>
                            <TableCell
                              className={styles.tableInHead}
                              align="center"
                            >
                              {/* <span
                                className={styles.action}
                                onClick={() => action(value.id)}
                              >
                                <span style={{ width: "75%" }}>
                                  {value.step.replace(/_/g, " ").toLowerCase()}{" "}
                                  &nbsp;{" "}
                                </span>

                                <img src={greater} alt="Greater" />
                              </span> */}
                              <span>
                                {value.status ===
                                  "CANCELLED" ? //   Application cancelled // <button className={styles.hiddenBtn1}>
                                  // </button>
                                  null : value.num === 0 ? (
                                    <Link
                                      to={`/dashboard/transactions/payment/${value.id}`}
                                    >
                                      <button className={styles.hiddenBtn}>
                                        <span style={{ width: "75%" }}>
                                          Pay Now
                                        </span>
                                        &nbsp;
                                        <img src={greater} alt="Greater" />
                                      </button>
                                    </Link>
                                  ) : value.num === 1 ? (
                                    <Link
                                      to={`/dashboard/my-applications/application-center/${value.id}`}
                                    >
                                      <button
                                        className={styles.hiddenBtn}
                                      // onClick={() => action(value.id)}
                                      >
                                        <span style={{ width: "75%" }}>
                                          Fill Application
                                        </span>
                                        &nbsp;
                                        <img src={greater} alt="Greater" />
                                      </button>
                                    </Link>
                                  ) : (
                                    <Link
                                      to={`/dashboard/my-applications/${value.id}/review-submitted-application`}
                                    >
                                      <button
                                        className={styles.hiddenBtn}
                                      // onClick={() => action(value.id)}
                                      >
                                        <span style={{ width: "75%" }}>
                                          Review Application
                                        </span>
                                        &nbsp;
                                        <img src={greater} alt="Greater" />
                                      </button>
                                    </Link>

                                    //      <span
                                    //   className={styles.action}
                                    // >
                                    //   <span style={{ width: "75%" }}>
                                    //     {value.step.replace(/_/g, " ").toLowerCase()}{" "}
                                    //     &nbsp;{" "}
                                    //   </span>

                                    //   <img src={greater} alt="Greater" />
                                    // </span>
                                  )}
                              </span>
                            </TableCell>
                            <TableCell align="center">
                              <IoChevronDownOutline
                                size={24}
                                style={{ color: "#7FA2B6", cursor: "pointer" }}
                              />
                              {/* <img src={greater2} alt="Greater" onClick={()=>action(value.id)} style={{cursor: 'pointer'}} /> */}
                              {/* <FaGreaterThan size={20} color="#969ba0" onClick={()=>action()} /> */}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  }
                >
                  <>
                    <div className={styles.hideShow}>
                      <div>
                        <CustomizedSteppers num={value.num} />
                      </div>
                      <div className={styles.hiddenBox}>
                        <div>
                          <h1 className={styles.hiddenHead}>
                            Country :{" "}
                            <span className={styles.hiddenHead2}>
                              {value.country}
                            </span>
                          </h1>
                          <br />
                          <br />

                          <h1 className={styles.hiddenHead}>
                            Visa type :{" "}
                            <span className={styles.hiddenHead2}>
                              Single entry
                            </span>
                          </h1>
                          <br />
                          {/* <br /> */}

                          <h1 className={styles.hiddenHead} style={{ marginTop: "10px" }}>
                            Service priority :{" "}
                            <span className={styles.hiddenHead2}>
                              {value.plan_type.toLowerCase()}
                            </span>
                          </h1>
                        </div>
                        <div>
                          <h1 className={styles.hiddenHead}>
                            Status :{" "}
                            <span className={styles.hiddenHead2}>
                              {value.step.replace(/_/g, " ").toLowerCase()}{" "}
                            </span>
                          </h1>
                          <br />
                          <h1 className={styles.hiddenHead}>



                            {
                              value.application.embassy_document ?
                                value.application.supervisor.status == "APPROVED" ?
                                value.status !== "CUSTOMER_APPROVED" ?
                                value.status !== "SUBMITTED" ?
                                  <div className={styles.documentBox}>
                                    <a href={value.application.embassy_document.link} style={{ marginRight: "50px" }} target="_blank" rel="noopener">
                                      <img
                                        src={documentImage}
                                        alt="Documents"
                                        className={styles.documentimage}
                                      />
                                    </a>
                                    {
                                      loading1 ?
                                        <span className={styles.hiddenBtn1}>
                                          <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                          </div>
                                        </span>
                                        :
                                        <span
                                          className={styles.hiddenBtn1}
                                          onClick={() => approve(value.id)}
                                        >
                                          {/* <span style={{ width: "75%" }}> */}
                                          Approve Application
                                          {/* </span>
                                          &nbsp;
                                          <img src={greater} alt="Greater" /> */}
                                        </span>
                                    }
                                  </div>
                                  : null
                                : null
                                : null
                                : null
                            }




                          </h1>
                          <br />
                          <h1 className={styles.hiddenHead}>
                            Visa Officer :{" "}
                            <span className={styles.hiddenHead2}>
                              {value.visa_officer}
                            </span>
                          </h1>
                        </div>
                        <div>
                          {value.status === "CANCELLED" ? (
                            <button className={styles.hiddenBtn1}>
                              Application cancelled
                            </button>
                          ) : value.num === 0 ? (
                            <Link
                              to={`/dashboard/transactions/payment/${value.id}`}
                            >
                              <button
                                className={styles.hiddenBtn}
                              // onClick={() => action(value.id)}
                              >
                                <span style={{ width: "75%" }}>Pay Now</span>
                                &nbsp;
                                <img src={greater} alt="Greater" />
                              </button>
                            </Link>
                          ) :
                            ((value.newNum) ? (
                              <Link
                                to={`/dashboard/my-applications/${value.id}/saved-applications`}
                              >
                                <button
                                  className={styles.hiddenBtn}
                                // onClick={() => action(value.id)}
                                >
                                  <span style={{ width: "75%" }}>
                                    Saved Applications
                                  </span>
                                  &nbsp;
                                  <img src={greater} alt="Greater" />
                                </button>
                              </Link>
                            )
                              : (
                                value.num === 1 ? (
                                  <Link
                                    to={`/dashboard/my-applications/application-center/${value.id}`}
                                  >
                                    <button
                                      className={styles.hiddenBtn}
                                    // onClick={() => action(value.id)}
                                    >
                                      <span style={{ width: "75%" }}>
                                        Fill Application
                                      </span>
                                      &nbsp;
                                      <img src={greater} alt="Greater" />
                                    </button>
                                  </Link>
                                ) : (
                                  <Link
                                    to={`/dashboard/my-applications/${value.id}/review-submitted-application`}
                                  >
                                    <button
                                      className={styles.hiddenBtn}
                                    // onClick={() => action(value.id)}
                                    >
                                      <span style={{ width: "75%" }}>
                                        Review Application
                                      </span>
                                      &nbsp;
                                      <img src={greater} alt="Greater" />
                                    </button>
                                  </Link>
                                )
                              )
                            )}
                        </div>
                      </div>
                    </div>
                  </>
                </Collapsible>
              ))}

              <div className={styles.allTableMobile}>
                <div className={styles.allDataMobile}>
                  <h2 className={styles.headMobile}>Country</h2>
                  <h2 className={styles.headMobile}>Action</h2>
                </div>
                {/* <hr /> */}
                {data.map((value, index) => (
                  <Collapsible
                    transitionTime={100}
                    trigger={
                      <div key={index} onClick={() => setOpen((open) => !open)}>
                        <hr className={styles.lineMobile} />

                        <div className={styles.boxMobile}>
                          <div className={styles.boxInMobile}>
                            <span className={styles.nameMobile}>
                              {value.country}{" "}
                              <IoChevronDownOutline
                                size={24}
                                style={{ color: "#7FA2B6", cursor: "pointer" }}
                              />
                              {/* <FaGreaterThan size={14} color="#969ba0" onClick={()=>action()} /> */}
                            </span>
                            <br />
                            <span className={styles.detailsType}>
                              {value.visa_type}
                            </span>
                            <div className={styles.detailsStatus}>
                              {value.status !== undefined ? (
                                <span>
                                  {value.status
                                    .replace(/_/g, " ")
                                    .toLowerCase()}
                                </span>
                              ) : (
                                <span>Not Available</span>
                              )}
                            </div>
                          </div>
                          <div className={styles.boxInMobile2}>
                            <span>
                              {value.status === "CANCELLED" ? // </button> //   Application cancelled // <button className={styles.btnOneMobile}>
                                null : value.num === 0 ? (
                                  <Link
                                    to={`/dashboard/transactions/payment/${value.id}`}
                                  >
                                    <button
                                      className={styles.btnOneMobile}
                                    // onClick={() => action(value.id)}
                                    >
                                      <span style={{ width: "75%" }}>
                                        Pay Now
                                      </span>
                                      &nbsp;
                                      <img src={greater} alt="Greater" />
                                    </button>
                                  </Link>
                                ) :
                                  value.num === 1 ? (
                                    <Link
                                      to={`/dashboard/my-applications/application-center/${value.id}`}
                                    >
                                      <button
                                        className={styles.btnOneMobile}
                                      // onClick={() => action(value.id)}
                                      >
                                        <span style={{ width: "75%" }}>
                                          Fill Application
                                        </span>
                                        &nbsp;
                                        <img src={greater} alt="Greater" />
                                      </button>
                                    </Link>
                                  ) : (
                                    <Link
                                      to={`/dashboard/my-applications/${value.id}/review-submitted-application`}
                                    >
                                      <button className={styles.btnOneMobile}>
                                        <span style={{ width: "75%" }}>Review</span>
                                        &nbsp;
                                        <img src={greater} alt="Greater" />
                                      </button>
                                    </Link>

                                    //      <span
                                    //   className={styles.btnOneMobile}
                                    // >
                                    //   <span style={{ width: "75%" }}>
                                    //     {value.step.replace(/_/g, " ").toLowerCase()}{" "}
                                    //     &nbsp;{" "}
                                    //   </span>

                                    //   <img src={greater} alt="Greater" />
                                    // </span>
                                  )}
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                  >
                    <>
                      <hr />
                      <div className={styles.hideShowMobile}>
                        <div>
                          <div>
                            <h1 className={styles.hiddenHead}>
                              Country :{" "}
                              <span className={styles.hiddenHead2}>
                                {value.country}
                              </span>
                            </h1>
                            <h1 className={styles.hiddenHead}>
                              Visa type :{" "}
                              <span className={styles.hiddenHead2}>
                                Single entry
                              </span>
                            </h1>
                            <h1 className={styles.hiddenHead}>
                              Service priority :{" "}
                              <span className={styles.hiddenHead2}>
                                {value.plan_type.toLowerCase()}
                              </span>
                            </h1>
                            <h1 className={styles.hiddenHead}>
                              Status :{" "}
                              <span className={styles.hiddenHead2}>
                                {value.step.replace(/_/g, " ").toLowerCase()}{" "}
                              </span>
                            </h1>
                            <h1 className={styles.hiddenHead}>
                              Visa Officer :{" "}
                              <span className={styles.hiddenHead2}>
                                {value.visa_officer}
                              </span>
                            </h1>
                          </div>

                          {
                            value.application.embassy_document ?
                              value.application.supervisor.status == "APPROVED" ?
                              value.status !== "SUBMITTED" ?
                                <div className={styles.documentBox}>
                                  <a href={value.application.embassy_document.link} style={{ marginBottom: "20px" }} target="_blank" rel="noopener">
                                    <img
                                      src={documentImage}
                                      alt="Documents"
                                      className={styles.documentimage}
                                    />
                                  </a>
                                  {
                                    loading1 ?
                                      <span className={styles.hiddenBtn1} >
                                        <div className="spinner-border" role="status">
                                          <span className="sr-only">Loading...</span>
                                        </div>
                                      </span>
                                      :
                                      <span
                                        className={styles.hiddenBtn1}
                                        onClick={() => approve(value.id)}
                                      >
                                        {/* <span style={{ width: "75%" }}> */}
                                        Approve Application
                                        {/* </span>
                                          &nbsp;
                                        <img src={greater} alt="Greater" /> */}
                                      </span>
                                  }

                                </div>
                                : null
                              : null
                              : null
                          }


                         

                          {value.status === "CANCELLED" ? (
                            <div className={styles.btnMobileCont}>
                              <button className={styles.lastBtnMobile1}>
                                Application cancelled
                              </button>
                            </div>
                          ) : value.num === 0 ? (
                            <Link
                              to={`/dashboard/transactions/payment/${value.id}`}
                            >
                              <div className={styles.btnMobileCont}>
                                <button className={styles.lastBtnMobile}>
                                  <span style={{ width: "75%" }}>Pay Now</span>
                                  &nbsp;
                                  <img src={greater} alt="Greater" />
                                </button>
                              </div>
                            </Link>
                          ) :
                            ((value.newNum) ? (
                              <Link
                                to={`/dashboard/my-applications/${value.id}/saved-applications`}
                              >
                                <div className={styles.btnMobileCont}>
                                  <button className={styles.lastBtnMobile}>
                                    <span style={{ width: "75%" }}>
                                      Saved Applications
                                    </span>
                                    &nbsp;
                                    <img src={greater} alt="Greater" />
                                  </button>
                                </div>
                              </Link>
                            )
                              :

                              (value.num === 1 ? (
                                <Link
                                  to={`/dashboard/my-applications/application-center/${value.id}`}
                                >
                                  <div className={styles.btnMobileCont}>
                                    <button className={styles.lastBtnMobile}>
                                      <span style={{ width: "75%" }}>
                                        Fill Application
                                      </span>
                                      &nbsp;
                                      <img src={greater} alt="Greater" />
                                    </button>
                                  </div>
                                </Link>
                              ) : (
                                <Link
                                  to={`/dashboard/my-applications/${value.id}/review-submitted-application`}
                                >
                                  <div className={styles.btnMobileCont}>
                                    <button className={styles.lastBtnMobile2}>
                                      <span style={{ width: "75%" }}>
                                        Review Application
                                      </span>
                                      &nbsp;
                                      <img src={greater} alt="Greater" />
                                    </button>
                                  </div>
                                </Link>)
                              ))}
                        </div>
                      </div>
                    </>
                  </Collapsible>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}
